import { useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface LoanPreApprovalQuote {
  requested_amount: number;
  balance_requirement: number;
  commission_fee: number;
  minimum_alert_balance: number;
}

export interface LoanPreApprovalRequestInput {
  amount: number;
  purpose: string;
  request_id: string;
}

export interface LoanPreApprovalRequestResult {
  loan_id: string;
  loan_amount: number;
  loan_purpose: string;
  commission_paid: number;
  status: string;
}

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export function useLoanPreApprovalQuote() {
  return useMutation<APIResponse<LoanPreApprovalQuote>, APIError, number>(
    async (amount) =>
      (await post(
        `${API_URL_V3}/alert/loan/pre-approval-quote`,
        { amount },
        { headers: authHeaders() }
      )) as APIResponse<LoanPreApprovalQuote>
  );
}

export function useSubmitLoanPreApproval() {
  const queryClient = useQueryClient();

  return useMutation<
    APIResponse<LoanPreApprovalRequestResult>,
    APIError,
    LoanPreApprovalRequestInput
  >(
    async (payload) =>
      (await post(
        `${API_URL_V3}/alert/loan/pre-approval-request`,
        payload,
        { headers: authHeaders() }
      )) as APIResponse<LoanPreApprovalRequestResult>,
    {
      onSuccess: async () => {
        // Cache refresh failures must not turn a completed paid request into an error.
        await Promise.allSettled([
          queryClient.invalidateQueries("quick-loans"),
          queryClient.invalidateQueries("accountTransactions"),
          queryClient.invalidateQueries("alert-account-enquiry"),
        ]);
      },
    }
  );
}
